<template>
  <v-row>
    <v-col md="8" offset-md="2">
      <div class="subtitle-2 font-weight-light">
        <p>
          <a
            href="https://www.univ-lille.fr/etudes/sinformer-sorienter"
            target="_blank"
            >La Direction de l'Orientation</a
          >
          met en oeuvre pour le compte du Président de l'Université de Lille un
          traitement informatisé de données personnelles ayant pour objet : la
          réorientation des publics concernés à l'issue du premier semestre.<br /><br />
          Le traitement a fait l'objet d'une déclaration au registre des
          traitements de l'Université de Lille sous la référence n° 2018137. Sa
          base légale repose sur l'exécution de la mission d'intérêt public (<a
            href="https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX%3A32016R0679#d1e1937-1-1"
            target="_blank"
            >RGPD. art. 6.1.e</a
          >) de réorientation (C. éduc.,
          <a
            href="https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000027747735/2013-07-24"
            target="_blank"
            >art. L. 123-2-1</a
          >).<br /><br />
          Les données collectées seront communiquées aux membres du personnel de
          l'Université concernés par le processus de réorientation des étudiants
          : Personnels de la Direction de l'Orientation et des relais scolarité,
          doyennes et doyens des facultés, directrices et directeurs d'UFR,
          enseignants et responsables des formations concernées, responsables
          adminitratifs d'UFR et secrétaires pédagogiques.
          <br /><br />
          Les données seront conservées jusqu'à l'ouverture de la procédure de
          réorientation de l'année n+1.<br /><br />
          Au-delà, ces données peuvent être archivées sur un support distinct et
          à accès très limité, conformément aux règles applicables en matière
          d'archives publiques et d'archives privées.<br /><br />
          Vous pouvez accéder aux données vous concernant, demander leur
          rectification, exercer vos droits de limitation et d’opposition au
          traitement de vos données (Consultez le site
          <a href="http://cnil.fr" target="_blank">cnil.fr</a> pour plus
          d’informations sur vos droits).<br /><br />
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez adresser votre demande à
          l’adresse :
          <a href="mailto:direction-suaio@univ-lille.fr"
            >direction-suaio@univ-lille.fr</a
          >
          ou contacter le délégué à la protection des données
          <a href="mailto:dpo@univ-lille.fr">dpo@univ-lille.fr</a>. <br /><br />
          Si vous estimez, après nous avoir contacté, que vos droits
          "Informatique et Libertés" ne sont pas respectés, vous pouvez adresser
          une réclamation à la
          <a href="http://cnil.fr" target="_blank">CNIL</a>.
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InfoRGPD",
};
</script>
